/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.querySelectorAll(".allocation-selectors").forEach(function(container){
    container.querySelectorAll("select").forEach(function(dropdown){
        dropdown.addEventListener("change", function(event){
            var quantity = parseInt(event.target.value);
            var priceNode = container.querySelector(".price");
            var priceNodeInitialValue = priceNode.dataset.initialPrice;
            if (Number.isInteger(quantity)){
                var smallestDenominationCurrency = parseFloat(priceNodeInitialValue);
                var updatedSmallestCurrency = smallestDenominationCurrency * quantity;
                var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(updatedSmallestCurrency / 100);
                priceNode.innerHTML = `<b>${currency}</b>`;
            }
        })
    })
})